<template>
	<section class="confirm">
		<div class="logo">
			<div class="logo-img"></div>
			<div class="logo-text"></div>
		</div>
		<div v-if="!loading && !error" class="confirm-success">
			<h2>E-mail verification successful!</h2>
			<p>
				You will be redirected shortly to the HyperCloud main page,
				where you can start using your account.
			</p>
		</div>
		<div v-if="!loading && error" class="confirm-fail">
			<h2 class="text-center text-danger">E-mail verification failed!</h2>
			<ErrorAlert :error="error" />
		</div>
		<div v-if="loading" class="confirm-loading">
			<Spinner />
		</div>
	</section>
</template>

<script>
import Spinner from "../shared/Spinner";
import ErrorAlert from "../shared/ErrorAlert";
import Register from "../../services/register";

export default {
	name: "Confirm",
	components: {
		Spinner,
		ErrorAlert,
	},
	data() {
		return {
			token: null,
			loading: false,
			error: null,
		};
	},
	mounted() {
		this.token = this.$route.query.token;
		if (this.token) {
			this.sendConfirmationRequest();
		}
	},
	methods: {
		sendConfirmationRequest() {
			this.loading = true;
			this.err = null;
			Register.instance()
				.confirmEmail(this.token)
				.then(() => {
					this.loading = false;
					setTimeout(() => {
						this.$router.push({ path: "/console/login" });
					}, 3000);
				})
				.catch((err) => {
					this.loading = false;
					this.error = err;
				});
		},
	},
	watch: {
		"$route.query.token": function () {
			this.token = this.$route.query.token;
		},
	},
};
</script>

<style scoped>
.confirm {
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	padding-top: 8rem;
}
.confirm-success {
	text-align: center;
}
.confirm-fail {
	max-width: 90rem;
	width: 100%;
}
.confirm-loading {
	position: relative;
	width: 100%;
	height: 200px;
}
.logo {
	max-width: 500px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 5rem;
}
.logo-img {
	height: 60px;
	width: 60px;
	background: url("../../assets/logo/HyperCloudLogo.svg");
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
}
.logo-text {
	height: 78px;
	width: 200px;
	background: url("../../assets/logo/HyperCloudLogoText.svg");
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	margin-left: 1rem;
	margin-top: 1rem;
}
</style>